module.exports = __webpack_public_path__ + "img/splash.fbf91d01.jpg";